{
  "familyId": "MET-OPP-VIERKANT",
  "questions": [
    {
      "id": "MET-OPP-VIERKANT-001",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een tegelzetter legt een vierkante terrastegel met zijden van 6 dm. Wat is de oppervlakte?",
      "options": ["36 dm²", "24 dm²", "12 dm²", "42 dm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "square",
            "base": 6,
            "height": 6,
            "unit": "dm",
            "showGrid": false,
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte vierkant",
            "content": "Formule: oppervlakte = zijde × zijde. Een vierkant heeft 4 gelijke zijden. Dus: 6 × 6 = 36 dm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_area_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "De oppervlakte van een vierkant = zijde × zijde. De zijde is 6 dm, dus: 6 × 6 = 36 dm².",
        "solutionSteps": [
          "Lees de zijde af: 6 dm",
          "Gebruik de formule: oppervlakte = zijde × zijde",
          "Reken uit: 6 × 6 = 36 dm²"
        ],
        "distractorExplanations": {
          "0": "Goed! 6 × 6 = 36 dm².",
          "1": "Dat is de omtrek (4 × 6 = 24), niet de oppervlakte. Onthoud: oppervlakte = zijde × zijde, omtrek = 4 × zijde.",
          "2": "Je deed 6 × 2. Maar bij oppervlakte vermenigvuldig je de zijde met zichzelf: 6 × 6 = 36.",
          "3": "Reken 6 × 6 nog eens na — dat is 36, niet 42."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Verwart oppervlakte met omtrek", "optionIndex": 1 },
          { "id": "met.opp-optellen-ipv-vermenigvuldigen", "label": "Optellen of × 2 i.p.v. zijde × zijde", "optionIndex": 2 },
          { "id": "met.opp-rekenfout", "label": "Rekenfout in vermenigvuldiging", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-VIERKANT-002",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een tuinarchitect ontwerpt een vierkante moestuin met een oppervlakte van 49 m². Hoe lang is elke zijde?",
      "options": ["49 m", "3 m", "7 m", "14 m"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "square",
            "base": null,
            "height": null,
            "unit": "m",
            "showGrid": false,
            "showDimensions": false,
            "label": "? × ? = 49 m²"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zijde berekenen",
            "content": "Als oppervlakte = zijde × zijde, dan is de zijde = √oppervlakte. √49 = 7. Elke zijde is 7 m.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_side_from_area",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Welk getal × zichzelf = 49? Dat is 7, want 7 × 7 = 49. Elke zijde is 7 m.",
        "solutionSteps": [
          "Gegeven: oppervlakte = 49 m²",
          "Formule omdraaien: zijde = √oppervlakte",
          "Welk getal × zichzelf = 49? → 7 × 7 = 49",
          "Elke zijde is 7 m"
        ],
        "distractorExplanations": {
          "0": "49 m² is de oppervlakte, niet de zijde. Zijde = √oppervlakte = √49 = 7 m.",
          "1": "3 × 3 = 9, niet 49. Het juiste antwoord is 7, want 7 × 7 = 49.",
          "2": "Goed! √49 = 7, dus elke zijde is 7 m.",
          "3": "Bij een vierkant deel je niet door 2 — je neemt de wortel: √49 = 7, niet 14."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.opp-zijde-verward", "label": "Verwart oppervlakte met zijde", "optionIndex": 0 },
          { "id": "met.opp-wortel-fout", "label": "Fout in worteltrekken", "optionIndex": 1 },
          { "id": "met.opp-delen-door-2-ipv-wortel", "label": "Door 2 delen i.p.v. wortel trekken", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-VIERKANT-003",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een hekwerkmonteur plaatst een hek rondom een vierkant terrein met zijden van 9 m. Wat is de omtrek?",
      "options": ["81 m", "36 m", "18 m", "27 m"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "square",
            "base": 9,
            "height": 9,
            "unit": "m",
            "showGrid": false,
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek vierkant",
            "content": "Omtrek = 4 × zijde. Een vierkant heeft 4 gelijke zijden. Dus: 4 × 9 = 36 m. Let op: omtrek ≠ oppervlakte! Omtrek = rondom, oppervlakte = binnenin.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_perimeter_vs_area",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De omtrek van een vierkant = 4 × zijde = 4 × 9 = 36 m. Een hek gaat rondom, dus je berekent de omtrek (niet de oppervlakte).",
        "solutionSteps": [
          "Lees de zijde af: 9 m",
          "Gebruik de formule: omtrek = 4 × zijde",
          "Reken uit: 4 × 9 = 36 m"
        ],
        "distractorExplanations": {
          "0": "81 m² is de oppervlakte (9 × 9 = 81), niet de omtrek. Een hek gaat rondom → omtrek = 4 × zijde.",
          "1": "Goed! 4 × 9 = 36 m.",
          "2": "Je rekende 2 × 9. Maar een vierkant heeft 4 zijden, dus omtrek = 4 × 9 = 36 m.",
          "3": "Je rekende 3 × 9. Maar een vierkant heeft 4 zijden (geen 3), dus 4 × 9 = 36 m."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Verwart omtrek met oppervlakte", "optionIndex": 0 },
          { "id": "met.omtrek-aantal-zijden-vierkant", "label": "Verkeerd aantal zijden gebruikt", "optionIndex": 2 },
          { "id": "met.omtrek-aantal-zijden-vierkant", "label": "Verkeerd aantal zijden gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-VIERKANT-004",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "fill_in",
      "question": "Een vierkant tafelblad heeft zijden van 8 dm. Bereken de oppervlakte in dm².",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["64", "64 dm²"],
        "placeholder": "Typ de oppervlakte...",
        "caseSensitive": false
      },
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "square",
            "base": 8,
            "height": 8,
            "unit": "dm",
            "showGrid": false,
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte vierkant",
            "content": "Oppervlakte = zijde × zijde = 8 × 8 = 64 dm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_area_fill_in",
      "variantIndex": 4,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "De oppervlakte van een vierkant = zijde × zijde = 8 × 8 = 64 dm².",
        "solutionSteps": [
          "Lees de zijde af: 8 dm",
          "Gebruik de formule: oppervlakte = zijde × zijde",
          "Reken uit: 8 × 8 = 64 dm²"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    },
    {
      "id": "MET-OPP-VIERKANT-005",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een tegelzetter betegelt een vierkante kamer met zijden van 5 meter. Tegels kosten €12 per m². Wat kosten de tegels in totaal?",
      "options": ["€240", "€360", "€120", "€300"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "square",
            "base": 5,
            "height": 5,
            "unit": "m",
            "showGrid": false,
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte en kosten",
            "content": "Stap 1: Oppervlakte = 5 × 5 = 25 m². Stap 2: Kosten = 25 × €12 = €300.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_area_context",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Eerst de oppervlakte: 5 × 5 = 25 m². Dan de kosten: 25 m² × €12 per m² = €300.",
        "solutionSteps": [
          "Bereken de oppervlakte: 5 × 5 = 25 m²",
          "Vermenigvuldig met de prijs per m²: 25 × €12 = €300"
        ],
        "distractorExplanations": {
          "0": "Je gebruikte de omtrek (4 × 5 = 20 m) × €12 = €240. Maar tegels bedekken de vloer (oppervlakte), niet de rand.",
          "1": "Je rekende met 6 × 5 = 30 m². Maar de kamer is vierkant met zijden van 5 m: 5 × 5 = 25 m².",
          "2": "Je deed 2 × 5 = 10 × €12 = €120. Oppervlakte vierkant = zijde × zijde, niet 2 × zijde.",
          "3": "Goed! 5 × 5 = 25 m², en 25 × €12 = €300."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.opp-omtrek-verward", "label": "Gebruikt omtrek i.p.v. oppervlakte", "optionIndex": 0 },
          { "id": "met.opp-verkeerde-afmeting", "label": "Verkeerde afmeting gebruikt", "optionIndex": 1 },
          { "id": "met.opp-optellen-ipv-vermenigvuldigen", "label": "× 2 i.p.v. zijde × zijde", "optionIndex": 2 }
        ]
      }
    }
  ]
}